import { colors } from 'baseui/tokens';
import { capitalize, string2money } from 'common/utils/string';
import Text from 'components/elements/text';
import { SeparatorHorizontal, SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';

import { ActivityContainer, ActivityContent, Container } from './styles';
import { ActivitySaleGuestItemFormType } from '../form-type';

interface Props {
  data: ActivitySaleGuestItemFormType[];
  isGrouped?: boolean;
}

export default function SummaryItem(props: Props) {
  const { data: _data, isGrouped } = props;

  const data = React.useMemo(() => {
    const temp: {
      name: string;
      items: {
        name: string;
        price: number;
        itemPrice: number;
        qty: number;
        customId: string;
      }[];
    } = {
      items: [],
      name: '',
    };
    if (isGrouped) {
      temp.name = _data.map((val) => val.guestName).join(', ');
      temp.items = _data.reduce<
        {
          name: string;
          price: number;
          itemPrice: number;
          qty: number;
          customId: string;
        }[]
      >((prev, curr) => {
        const val = curr.activitySaleGuestDetails.map((item) => {
          const name = [item.activityCode, capitalize(item.type)]
            .filter(Boolean)
            .join(' | ');

          return {
            customId: item.customId || '',
            name,
            price: item.totalPrice * _data.length,
            itemPrice: item.price,
            qty: item.qty * _data.length,
          };
        });
        return val;
      }, []);
    } else {
      temp.name = _data[0].guestName || '';
      temp.items = _data[0].activitySaleGuestDetails.map((item) => ({
        name: [
          `${item.activityCode} - ${item.activityName}`,
          capitalize(item.type),
        ]
          .filter(Boolean)
          .join(' | '),
        price: item.totalPrice,
        itemPrice: item.price,
        qty: item.qty,
        customId: item.customId || '',
      }));
    }

    return temp;
  }, [_data, isGrouped]);

  return (
    <Container>
      <>
        {isGrouped ? (
          <>
            {_data.map((item, idx) => (
              <React.Fragment key={idx}>
                <Text variant="LabelSmall">{item.guestName}</Text>
                <SeparatorVertical $margin={8} />
              </React.Fragment>
            ))}
          </>
        ) : (
          <>
            <Text variant="LabelSmall">{data.name}</Text>
            <SeparatorVertical $margin={8} />
          </>
        )}
        {data.items.map((item, idx) => (
          <ActivityContainer key={idx}>
            <ActivityContent>
              <Text variant="LabelSmall">
                (x{item.qty || 0}) {item.name}
              </Text>
              <SeparatorHorizontal $margin={8} />
              <Text variant="LabelSmall" $style={{ color: colors.gray500 }}>
                {`@ Rp ${string2money(item.itemPrice || 0)}`}
              </Text>
            </ActivityContent>
            <Text variant="LabelSmall">
              {`Rp ${string2money(item.price || 0)}`}
            </Text>
          </ActivityContainer>
        ))}
      </>
    </Container>
  );
}
